// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "4be63a2b82bd420c" + ".js";
};